'use strict';

exports.__esModule = true;
exports['default'] = isDisposable;

function isDisposable(obj) {
  return Boolean(obj && typeof obj.dispose === 'function');
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/disposables/modules/isDisposable.js
// module id = 114
// module chunks = 0